import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import 'react-phone-input-2/lib/style.css'
import AxiosService from "../services/axios.service";
const API_PATH = "agencies";

function AddEditAgent({ history, match }) {

    const { id } = match.params;
    const isAddMode = !id;

    // form validation rules 
    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required('Agency Name is required'),
        description: Yup.string()
    });

    // functions to build form returned by useForm() hook
    const { register, handleSubmit, reset, setValue, errors, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    function onSubmit(data) {
        return isAddMode
            ? createAgency(data)
            : updateAgency(id, data);
    }

    function createAgency(data) {
        return AxiosService.create(API_PATH, data)
            .then(() => {
                //handle email already in use
                console.log(data);
                history.push('.');
            })
    }

    function updateAgency(id, data) {
        return AxiosService.update(API_PATH, id, data)
            .then(() => {
                //handle email already in use
                console.log("the big n");
                history.push('..');
            })
    }

    useEffect(() => {

        if (!isAddMode) {
            // get user and set form fields
            AxiosService.get(API_PATH, id).then(x => {
                var agency = x.data;
                const fields = ['name', 'phone', 'description', 'street_address', 'city', 'state', 'zip', 'latitude', 'longitude'];
                fields.forEach(field => setValue(field, agency[field]));
            })
        }
    }, []);

    const onFocus = event => {
        if (event.target.autocomplete) {
            event.target.autocomplete = "whatever";
        }
    };

    return (
        <form onFocus={onFocus} onSubmit={handleSubmit(onSubmit)} onReset={reset}>
            <h1>{isAddMode ? 'Add Agency' : 'Edit Agency'}</h1>
            <div className="form-row">
                <div className="form-group col-5">
                    <label>Agency Name</label>
                    <input autoComplete="off" name="name" type="text" ref={register} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.name?.message}</div>
                </div>
            </div>

            <div className="form-row">
                <div className="form-group col-5">
                    <label>Description</label>
                    <textarea autoComplete="off" name="description" rows={7} style={{ width: '925px' }} ref={register} className={`form-control ${errors.description ? 'is-invalid' : ''}`} />
                </div>
            </div>

            <div className="form-group">
                <button type="submit" disabled={formState.isSubmitting} className="btn btn-primary">
                    {formState.isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                    Save
                </button>
                <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
                {/* <map /> */}


            </div>
        </form>
    );
}

export { AddEditAgent };